import { useEffect, useRef, useState } from "react";
import AdvanceRightModal from "../../../components/Modal/AdvanceRightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { handleDropdownClose } from "../../../utils/utils";
import ContactAdvanceFilterData from "./ContactAdvanceFilterData";

// ✅ REAL empty state (used for clear + API)
const EMPTY_ADVANCE_FILTER = [];

const ContactAdvanceFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(
    localStorage.getItem("selectedSavefilterId") || ""
  );

  // ✅ UI-only empty row
  const initialEmptyState = [
    {
      id: Date.now(),
      condition: "AND",
      filters: [{ join: null, field: "", operator: "", value: "" }],
    },
  ];

  const [localFilterData, setLocalFilterData] = useState(
    filterData?.length ? filterData : initialEmptyState
  );

  /* ---------------- SYNC WHEN OPEN ---------------- */
  useEffect(() => {
    if (isSidebarOpen) {
      setLocalFilterData(filterData?.length ? filterData : initialEmptyState);
    }
  }, [isSidebarOpen, filterData]);

  useEffect(() => {
    handleDropdownClose(dropdownRef, () => setIsSidebarOpen(false));
  }, []);

  /* ---------------- APPLY FILTER ---------------- */
  const handleFilter = () => {
    onSetFilterData(localFilterData);
    onCallApiAgain(localFilterData);
    localStorage.setItem("advanceFilterData", JSON.stringify(localFilterData));
    localStorage.setItem("filterData", JSON.stringify(localFilterData));
    setIsSidebarOpen(false);
  };

  /* ---------------- CLEAR FILTER ---------------- */
  const handleClearAll = () => {
    // ✅ Real clear
    onSetFilterData(EMPTY_ADVANCE_FILTER);
    onCallApiAgain(EMPTY_ADVANCE_FILTER);

    // ✅ UI reset
    setLocalFilterData(initialEmptyState);

    // ✅ Clear saved filter selection
    setSelectedSaveFilterId("");

    localStorage.removeItem("advanceFilterData");
    localStorage.removeItem("selectedSavefilterId");

    setIsSidebarOpen(false);
  };

  /* ---------------- CLEAR FROM SAVED FILTER COMPONENT ---------------- */
  const handleClearFromSavedFilter = () => {
    // ✅ This gets called from SavedFilterComponent's Clear button
    onSetFilterData(EMPTY_ADVANCE_FILTER);
    onCallApiAgain(EMPTY_ADVANCE_FILTER);
    setLocalFilterData(initialEmptyState);
    setSelectedSaveFilterId("");
  };

  /* ---------------- SELECT SAVED FILTER ---------------- */
  const handleSelectFilter = (value) => {
    // ✅ Extract advance_filters from saved search
    const filters = value?.advance_filters || EMPTY_ADVANCE_FILTER;

    onSetFilterData(filters);
    onCallApiAgain(filters);
    setLocalFilterData(filters.length ? filters : initialEmptyState);

    localStorage.setItem("advanceFilterData", JSON.stringify(filters));
    localStorage.setItem("filterData", JSON.stringify(filters));
  };

  /* ---------------- SAVE DATA WITH ADVANCE_FILTERS KEY ---------------- */
  const saveSearchFilterData = {
    advance_filters: localFilterData, // ✅ This key distinguishes it from normal filters
  };

  /* ---------------- CORRECT COUNT ---------------- */
  const filterCount =
    localFilterData?.filter(group =>
      group?.filters?.some(
        f => f.field || f.operator || f.value
      )
    ).length || 0;

  return (
    <>
      {/* SAVED FILTER HEADER */}
      <SavedFilterComponent
        from="Contact Filter Save Filter"
        filterType="advance" // ✅ Explicitly set as "advance"
        count={filterCount}
        isSidebarOpen={isSidebarOpen}
        initialFilterData={EMPTY_ADVANCE_FILTER}
        selectedSavefilterId={selectedSavefilterId}
        saveSearchFilterData={saveSearchFilterData}
        onSetIsSidebarOpen={setIsSidebarOpen}
        onSetFilterData={handleClearFromSavedFilter}
        onCallApiAgain={onCallApiAgain}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
        isMulti={true}
      />

      {/* ADVANCE FILTER MODAL */}
      <AdvanceRightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Advance Filter"
        from="contact"
        onFilter={handleFilter}
        onClose={() => setIsSidebarOpen(false)}
        onClearAll={handleClearAll}
      >
        <ContactAdvanceFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={localFilterData}
          onSetFilterData={setLocalFilterData}
        />
      </AdvanceRightModal>
    </>
  );
};

export default ContactAdvanceFilter;
